const React = window.React;
const { createElement, useEffect, useRef, useState } = React;
import { Card, message, Modal, Space, Upload } from 'antd';
import { Button, Icon } from '@alifd/next';
import { baseUrl } from '../../utils';
const importUrl = `${baseUrl}/modules/transition/form/uploadExcelToJson`;
const ImportExcelButton = ({ importTemplateList, onImport, }) => {
    const [importLoading, setImportLoading] = useState(false);
    const [importModalVisible, setImportModalVisible] = useState(false);
    const handleChange = (info) => {
        console.log('info', info);
        const { status } = info.file;
        setImportLoading(true);
        if (status === 'done') {
            setImportLoading(false);
            console.log('response', info.file.response);
            const { data } = info.file.response;
            setImportModalVisible(false);
            onImport(data);
            message.success(`文件导入成功.`);
        }
        else if (status === 'error') {
            setImportLoading(false);
            message.error(`文件导入失败.`);
        }
    };
    const beforeUpload = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = e => {
                if (e.total > 5 * 1024 * 1024) {
                    message.error(`文件大小不能超过5M`);
                    reject();
                    return;
                }
            };
            reader.readAsDataURL(file);
        });
    };
    let templateUrl = '';
    if (importTemplateList && importTemplateList.length) {
        templateUrl = JSON.parse(importTemplateList) && JSON.parse(importTemplateList).length ? JSON.parse(importTemplateList)[0].url : '';
    }
    return (createElement(Fragment, null,
        createElement(Button, { type: "primary", onClick: () => setImportModalVisible(true) },
            createElement(Icon, { type: "upload" }),
            " \u5BFC\u5165"),
        createElement(Modal, { title: "\u5BFC\u5165Excel\u6587\u4EF6", open: importModalVisible, maskClosable: false, onOk: () => setImportModalVisible(false), onCancel: () => setImportModalVisible(false), okButtonProps: { loading: importLoading } },
            createElement(Card, { bordered: false, bodyStyle: { padding: '0 0 0 80px' } },
                createElement(Space, { size: 12 },
                    createElement(Upload, { action: importUrl, headers: {
                            Authorization: `Bearer ${window.token || localStorage.getItem('token')}`,
                        }, maxCount: 1, accept: '.xlsx,.xls', onChange: handleChange },
                        createElement(Button, null,
                            createElement(Icon, { type: "upload" }),
                            " \u4E0A\u4F20Excel\u6587\u4EF6")),
                    templateUrl && createElement("a", { href: templateUrl, target: "_blank", rel: "noopener noreferrer" }, "\u4E0B\u8F7D\u5BFC\u5165\u6A21\u677F"))))));
};
export default ImportExcelButton;
